export default __webpack_public_path__ + "static/media/EitanLogoSmall.bdbdd9e2.PNG";